import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getConfirmAnalyses = asyncThunkWrapper({ 
  model: 'confirmAnalyses', 
  action: 'getConfirmAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at']
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/confirm_flow/confirm_analyses', { params });

    return response.data;
  } 
});
export const getConfirmAnalysis = asyncThunkWrapper({ 
  model: 'confirmAnalyses', 
  action: 'getConfirmAnalysis', 
  func: async ({ id, cable = false }) => {
    const params = { attributes: ['id', 'status', 'updated_at'] };
    const response = await axios.get(`/confirm_analyses/${id}`, { params });
      
    return { data: response.data, cable };
  } 
});
export const clearLocalConfirmAnalyses = createAction('confirmAnalyses/clearLocalConfirmAnalyses');
export const clearLocalActiveConfirmAnalysis = createAction('confirmAnalyses/clearLocalActiveConfirmAnalysis');